
import React, { useState, useEffect } from "react";
import ObjectForm from "../../Common/ObjectForm";
import http from "../../Common/RestAPIHandler";
import {EmployeesLang} from "../../Common/Languages";

const EmployeeCredentialForm = props => {
  const [formFields, setFormFields] = useState();
	const [categories, setCategories] = useState([]);
  const lang = localStorage.getItem("languages");  

	useEffect(() => {
		http.Get(
			`categories?tenant=${props.companyTenant?props.companyTenant.id:null}&category_type=Account Type`,
			(data) => {
				var valueMap = {};
				for (let i = 0; i < data.length; i++) {
					valueMap[data[i].id] = data[i].category_name;
				}
				setCategories(valueMap);
			},
			() => {}
		);
  }, []);

  useEffect(() => {
    if(categories){
      setFormFields([
        { 
          id: "category", 
          label: EmployeesLang.ACCOUNTTYPE[lang], 
          type: "select",
          valueMap: categories
        },
        { 
          id: "description", 
          label: EmployeesLang.DESCRIPTION[lang], 
          type: "text", 
        },
        { 
          id: "username", 
          label: EmployeesLang.USERNAME[lang]+" *", 
          type: "text", 
        },
        { 
          id: "password", 
          label: EmployeesLang.PASSWORD[lang]+" *", 
          type: "password", 
        },
        { 
          id: "website", 
          label: EmployeesLang.WEBSITE[lang], 
          type: "text", 
        },
      ]);

    }

  }, [categories]);


  return(
    <div>{formFields && <ObjectForm {...props} url={`employee_credentials`} formName={EmployeesLang.EmployeeCredential[lang]} formFields={formFields}/>}</div>
  );
};

export default EmployeeCredentialForm;
